import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { RouteColumn, RouteRow } from '../../../../../../../components/layout'
import { Time, TowingRecordJobStatus } from '../../../../../../../common/types'
import { LocationInputMap, toMapData } from '../../../../../../../components/layout/form/input/LocationInputMap'
import { ArrivalDateTimeInput } from '../../../../../../../components/layout/form/input/DateTimeInput'
import { format } from 'date-fns'
import { CollapseContent } from '../../../../../../../components/Collapse/CollapseContent'
import { ArrivedAtBreakdownLocationProps } from './ArrivedForm'
import { routeSubformMessages } from '../../messages'

export const ArrivedAtBreakdownLocationForm: React.FunctionComponent<ArrivedAtBreakdownLocationProps> = ({
  setValue,
  action,
  getValue,
  setRouteLocation,
  setDateField,
  clear,
}) => {
  const intl = useIntl()
  const [edit, setEdit] = useState<boolean>(action === 'edit-arrived')

  useEffect(() => {
    if (action === 'edit-arrived') {
      if (!edit) setEdit(true)
    } else {
      if (edit) setEdit(false)
    }
  }, [edit, action, setEdit])
  
  return (
    <CollapseContent>
      <RouteRow>
        <RouteColumn>
          <LocationInputMap
            addressLabel={intl.formatMessage(routeSubformMessages.address)}
            addressName={`arrivalRoute.address`}
            cityLabel={intl.formatMessage(routeSubformMessages.city)}
            cityName={`arrivalRoute.city`}
            coordsName={`arrivalRoute.coords`}
            zipcodeName={`arrivalRoute.zipcode`}
            required
            coordsRequired
            getValue={getValue}
            values={toMapData(
              getValue(`arrivalRoute.address`),
              getValue(`arrivalRoute.city`),
              getValue(`arrivalRoute.coords`),
              getValue(`arrivalRoute.zipcode`)
            )}
            setValue={setValue}
            disabled={!edit}
            setRouteLocation={setRouteLocation}
            stationId={null}
            clear={clear}
          />
        </RouteColumn>
        <RouteColumn>
          <ArrivalDateTimeInput
            label={intl.formatMessage(routeSubformMessages.arrivalTime)}
            name={`arrivalRoute`}
            customOnChange={() => {
              const value = (format(new Date(), 'HH:mm') as unknown) as Time
              setDateField('arrivalRoute.arrivalDate')
              setValue('arrivalRoute.arrivalTime', value)
            }}
            required
            disabled={!edit}
            showCurrentTimeBtn
          />
        </RouteColumn>
      </RouteRow>
    </CollapseContent>
  )
}

export const finishedAtDestinationEditableJobStatuses = [TowingRecordJobStatus.finished_at_destination]
